<template>
  <div>
    <ModalCardDefault
      :title="'Adicionar Produto'"
      @close="$emit('update:dialogItems', false)"
    >
      <ExpansionPanel
        v-model="panel"
        :title="'Informações do Produto'"
        :icon="$icons.box"
        readonly
      >
        <Row>
          <Col md="6">
            <Select
              v-model="productSelected"
              :items="products"
              item-text="name"
              item-value="id"
              label="Produto"
              :rules="[required]"
              @change="changeProduct"
            />
          </Col>
          <Col md="6">
            <TextField
              v-model="quantity"
              label="Quantidade"
              type="number"
              :rules="[required]"
              @input="calculateTotal"
            />
          </Col>
        </Row>
        <Row>
          <Col md="6">
            <TextField
              v-model="unit_value"
              label="Valor Unitário"
              type="number"
              :rules="[required]"
              @input="calculateTotal"
            />
          </Col>
          <Col md="6">
            <TextField
              v-model="total_value"
              label="Valor Total"
              type="number"
              readonly
            />
          </Col>
        </Row>
      </ExpansionPanel>
      <div class="d-flex justify-end mt-5">
        <Button
          :label="'Adicionar'"
          color="secondary"
          rounded
          @click="addItems"
        />
      </div>
    </ModalCardDefault>
  </div>
</template>

<script>
import ModalCardDefault from '@/components/ModalCardDefault.vue';
import {
  ExpansionPanel,
  Button,
  Row,
  Col,
  Select,
  TextField,
} from '@/components/vuetify';
import { formatCurrency, formatDatePT } from '@/utils';

export default {
  name: 'ItemsDataListItemsProductOrderDevolutionItems',
  components: {
    ModalCardDefault,
    ExpansionPanel,
    Button,
    Row,
    Col,
    Select,
    TextField,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    itemsDevolutions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      panel: [0],
      utils: {
        formatCurrency,
        formatDatePT,
      },
      slotsItems: [
        { field: 'qtd_devolution' },
        { field: 'qtd_returned' },
        { field: 'quantity' },
        { field: 'created_at' },
        { field: 'total_value' },
      ],
    };
  },
  computed: {
    headersOrderSaleItems() {
      return [
        {
          text: 'Devolver',
          value: 'qtd_devolution',
          width: 120,
        },
        {
          text: 'Devolvido',
          value: 'qtd_returned',
          width: 110,
        },
        {
          text: 'Data Venda',
          value: 'created_at',
          width: 90,
        },
        {
          text: 'Venda',
          value: 'order.order_number',
          width: 90,
        },
        {
          text: 'Item',
          value: 'item_number',
        },
        {
          text: 'Nome',
          value: 'name',
          width: 320,
        },
        {
          text: 'Qtde.',
          value: 'quantity',
          width: 90,
        },
        {
          text: 'Vlr. Total',
          value: 'total_value',
          width: 150,
        },
      ];
    },
    itemsTable() {
      const items = this.items.map((item) => {
        let qtd_returned = 0;

        this.itemsDevolutions.forEach((itemDevolution) => {
          if (itemDevolution.id === item.id) {
            qtd_returned += itemDevolution.qtd_devolution;
          }
        });

        return {
          ...item,
          qtd_returned,
        };
      });

      return items;
    },
  },
  methods: {
    async addItems() {
      this.$emit('addItemsOrderSale');
    },
    setReadonlyQtdDevolution(item) {
      return item.qtd_returned >= item.quantity;
    },
  },
};
</script>

<style lang="scss" scoped>
.item-input {
  height: 30px !important;
}
</style>
